export default __webpack_public_path__ + "static/media/cepeda.4fff9fee.png";